// extracted by mini-css-extract-plugin
export var loading = "LoadingIndicator-module--loading--0074f";
export var loadingPage = "LoadingIndicator-module--loadingPage--9b2db";
export var loadingindicator = "LoadingIndicator-module--loadingindicator--01267";
export var visuallyHidden = "LoadingIndicator-module--visuallyHidden--15022 visuallyHidden-module--visuallyHidden--0fa26";